import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Environment } from 'src/app/environment/environment';
import { AuthService } from '../auth/auth.service';
import { NOT_AVAILABLE_ROUTE } from './terminated-restriction.guard';

export const submoduleGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const environment = new Environment();

  if (!authService.isAuthenticated()) {
    authService.LogOut();
    return false;
  }

  // EN-18175 - re-read on every page so a termination or rehire applies on the next navigation (AC5).
  await authService.refreshEmployeeAccessModules();

  const { rights, redirectTo } = route.data;

  if (rights) {
    let isAllowed = false;
    rights.forEach((r: string) => {
      let check = authService.employeeAccessModules.includes(r);
      if (check) {
        isAllowed = true;
      }
    });

    if (!isAllowed) {
      // EN-18175 - a terminated employee opening a module outside their view, e.g. by URL, is told so
      // rather than bounced silently along the redirect chain (AC4).
      if (authService.isTerminatedRestricted) {
        router.navigate([NOT_AVAILABLE_ROUTE]);
        return false;
      }
      // While onboarding is incomplete the API grants Onboarding and nothing else, so EVERY guarded route
      // is denied. Following `redirectTo` then walks the chain summary -> documents -> ... -> pto, whose own
      // redirectTo is 'pto', and the guard would bounce off itself forever. Send them to the one module
      // they can actually use instead.
      router.navigate([
        authService.isOnboardingOnly() ? '/employee-onboarding' : redirectTo,
      ]);
      return false;
    } else {
      return true;
    }
  }
  return true;
};
